import MediaQueries from "../../utils/MediaQueries";

export default function initMobileMenu() {

    let mobileMenuSelector = $(".mobile-bottom-bar__list");

    const openDelay = 50,

        $button = $(".mobile-bottom-bar__list__item__link"),
        $container = $(".panel-wrapper"),
        $content = $(".panel"),
        $bodyWrapper = $("body, .body-wrapper"),

        buttonClass = "mobile-bottom-bar__list__item__link",
        containerClass = "panel-wrapper",
        contentClass = "panel",

        trigger = "data-open-panel",
        disableScrollClass = "u-disable-scroll",
        activeButtonClass = buttonClass + "--active",
        activeContentClass = contentClass + "--active",
        openContainerClass = containerClass + "--open",
        openingContainerClass = containerClass + "--opening";

    if(isHomeDetected())
      $("[data-open-panel='mobile-menu-home']").addClass("mobile-bottom-bar__list__item__link--active");

    $("[" + trigger + "]").click(function() {

        const $clickedLink = $(this);
        const clickedLinkTarget = $clickedLink.attr(trigger);

        toggleActiveLink($clickedLink);
        toggleActiveMenu($clickedLink);

        if (
          clickedLinkTarget === "mobile-menu-rubric" ||
          clickedLinkTarget === "mobile-menu-spectacle" ||
          (clickedLinkTarget === "mobile-menu-home" && isHomeDetected() ) ||
          (clickedLinkTarget === "mobile-menu-user" && $("#mobile-menu-user-link").hasClass("mobile-menu-user-link--logged"))
        ) {
            return false;
        }
    });

    function isHomeDetected() {
      const reg = new RegExp($("[data-open-panel='mobile-menu-home']").attr("href") + "$", "i");
      return !!window.location.href.match(reg);
    }

    function toggleActiveLink($clickedLink) {

        const $activeLink = $("." + activeButtonClass);

        // console.log("clickedLink", $clickedLink.attr(trigger), "activelink", $activeLink.attr(trigger) );

        $button.removeClass(activeButtonClass);

        if ($clickedLink.attr(trigger) === "mobile-menu-home") {

            $clickedLink.addClass(activeButtonClass);
            $bodyWrapper.removeClass(disableScrollClass);
            $container.removeClass(openContainerClass);

            window.setTimeout(function () {
                $container.removeClass(openingContainerClass);
            }, openDelay);

        } else if (($activeLink.attr(trigger) !== $clickedLink.attr(trigger)) && !($clickedLink.attr("class").indexOf("unlogged") !== -1)) {
            $clickedLink.addClass(activeButtonClass);
            $bodyWrapper.addClass(disableScrollClass);
            $container.addClass(openingContainerClass);

            window.setTimeout(function () {
                $container.addClass(openContainerClass);
            }, openDelay);

        } else {

            $bodyWrapper.removeClass(disableScrollClass);
            $container.removeClass(openContainerClass);

            window.setTimeout(function () {
                $container.removeClass(openingContainerClass);
                if(isHomeDetected()) {
                  $("[data-open-panel='mobile-menu-home']").addClass("mobile-bottom-bar__list__item__link--active");
                }
            }, openDelay);
        }
    }

    function toggleActiveMenu($clickedLink) {
        const clickedId = $clickedLink.attr(trigger);
        const $clicked = $("#" + clickedId);

        // console.log("clicked", $clicked, "clickedId", clickedId );

        if ($clickedLink.attr(trigger) !== "mobile-menu-home") {
            $content.removeClass(activeContentClass);
        }

        $clicked.addClass(activeContentClass);
    }

    // check to call the function only on mobile
    if((MediaQueries.isMobile() || MediaQueries.isTablet()) &&
        mobileMenuSelector.length > 0 && mobileMenuSelector[0].offsetWidth) {
        window.Analytics.sendLoadTime('mobileMenuReady');
    }
}



// WEBPACK FOOTER //
// ./js/navbar/mobile/NavbarMenu.js